export function errorHandler(error) {
    if (error.response) {
        if (error.response.data) {
            return error.response.data;
        }
    }

    return error.message;
}

export function getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
}

export function formatNumber(number, pos, padChar) {
    return number.toString().padStart(pos, padChar);
}

export function csvExport(content, fileName) {
    const blob = new Blob(["\ufeff" + content], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", fileName);
    link.click();
    URL.revokeObjectURL(url);
}

export function pdfExport(content, fileName) {
    
}

export function getDistance(p1, p2) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}

export function clientPointerRelativeToStage(clientX, clientY, stage) {
    return {
        x: clientX - stage.getContent().offsetLeft,
        y: clientY - stage.getContent().offsetTop
    };
}